"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promoImageComponent = exports.SpotShowImageComponent = void 0;
const app_1 = require("app");
const webexUI_1 = require("webexUI");
const PopupImage_1 = require("./PopupImage");
class SpotShowImageComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.spot-cascade';
    }
    OnInit() {
        this.el.forEach(element => {
            var _a;
            const isDisableImagePopup = ((_a = app_1.AttrService.data(element, 'disable-image-popup')) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'true' ? true : false;
            const hasVideo = !!element.querySelector('.play-video-button');
            const image = element.querySelector('img');
            !isDisableImagePopup && image.classList.add('clickable');
            image.addEventListener('click', event => {
                const isDesktop = (0, webexUI_1.detectBreakpoint)(webexUI_1.Breakpoint.LGScreen);
                if (!isDesktop || isDisableImagePopup || hasVideo) {
                    return;
                }
                const mediaItem = {
                    altText: event.target['alt'],
                    imageUrl: event.target['src'],
                    hasBorder: false,
                    caption: '',
                    videoUrl: '',
                    disableImagePopup: isDisableImagePopup,
                };
                const popupImageContainer = element.querySelector('.spot-cascade__popup-image-container');
                (0, PopupImage_1.renderPopupImage)(mediaItem, popupImageContainer);
            });
        });
    }
}
exports.SpotShowImageComponent = SpotShowImageComponent;
exports.promoImageComponent = new SpotShowImageComponent();
